/* UtilMax PDP behavior overrides v3
 * - Hide theme's product-info section (redundant with utx description)
 * - Move ReleasIt COD button into utx-hero-box just before .utx-atc
 * - Intercept .utx-atc / .add-to-cart-button clicks → abrir COD form
 * - Open COD form via window._rsiV2.setState({isOpen: true}) — vía directa, sin esperar el button click handler
 */
(function () {
  'use strict';

  var initialized = false;
  var pendingClick = null;
  var codObserver = null;

  function isProductPage() { return !!document.querySelector('main[data-template="product"]'); }

  function moveCODButton() {
    var codWrapper = document.querySelector('._rsi-buy-now-button-app-block-hook');
    var heroBox = document.querySelector('.utx-root .utx-hero-box');
    var utxAtc = document.querySelector('.utx-root .utx-atc');
    if (!codWrapper || !heroBox || !utxAtc) return false;
    if (heroBox.contains(codWrapper)) return true;
    utxAtc.parentNode.insertBefore(codWrapper, utxAtc);
    codWrapper.style.marginTop = '22px';
    codWrapper.style.marginBottom = '0';
    codWrapper.style.width = '100%';
    codWrapper.style.display = 'block';
    utxAtc.classList.add('utx-atc--secondary');
    return true;
  }

  function hideThemeProductInfo() {
    var selectors = [
      'main[data-template="product"] product-information',
      'main[data-template="product"] .shopify-section--main',
      'main[data-template="product"] [id^="shopify-section-template"][id*="main"]',
      'main[data-template="product"] .product-information',
      'main[data-template="product"] .product-details'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.style.display = 'none'; });
    });
    var sticky = document.querySelector('sticky-add-to-cart');
    if (sticky) sticky.style.display = 'none';
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.dataset.utxOriginalText = btn.dataset.utxOriginalText || btn.textContent.trim();
      btn.style.opacity = '0.7';
      btn.style.pointerEvents = 'none';
      btn.textContent = 'Cargando…';
    } else {
      if (btn.dataset.utxOriginalText) btn.textContent = btn.dataset.utxOriginalText;
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
    }
  }

  // INSTANT path: ReleasIt expone window._rsiV2.setState({isOpen: true}) que abre el form
  // directamente sin pasar por React click handler. Verified <100ms render.
  function openCODFormInstant() {
    try {
      if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
        window._rsiV2.setState({ isOpen: true });
        return true;
      }
    } catch (err) { /* fall through to button.click() fallback */ }
    return false;
  }

  function triggerCOD(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation && e.stopImmediatePropagation();
    }
    var srcBtn = e ? e.currentTarget : null;
    // Try instant API first
    if (openCODFormInstant()) return;
    // Fallback: native button click
    var codBtn = document.querySelector('#rsi_buy_now_button');
    if (codBtn) {
      codBtn.click();
      return;
    }
    // Not loaded — queue + show loading
    if (srcBtn) setButtonLoading(srcBtn, true);
    pendingClick = srcBtn;
    var tries = 0;
    var queued = setInterval(function () {
      if (openCODFormInstant()) {
        clearInterval(queued);
        if (pendingClick) setButtonLoading(pendingClick, false);
        pendingClick = null;
        return;
      }
      var btn = document.querySelector('#rsi_buy_now_button');
      if (btn) {
        clearInterval(queued);
        if (pendingClick) setButtonLoading(pendingClick, false);
        pendingClick = null;
        btn.click();
      } else if (++tries > 50) { // 5s max
        clearInterval(queued);
        if (pendingClick) setButtonLoading(pendingClick, false);
        pendingClick = null;
      }
    }, 100);
  }

  function interceptCartClicks() {
    document.querySelectorAll('.utx-atc').forEach(function (a) {
      if (a.dataset.utxIntercepted) return;
      a.dataset.utxIntercepted = '1';
      a.dataset.utxHref = a.getAttribute('href') || '';
      a.setAttribute('href', 'javascript:void(0)');
      a.setAttribute('role', 'button');
      a.addEventListener('click', triggerCOD, true);
    });
    document.querySelectorAll('main[data-template="product"] .add-to-cart-button:not(.sticky-add-to-cart__button)').forEach(function (b) {
      if (b.dataset.utxIntercepted) return;
      b.dataset.utxIntercepted = '1';
      b.addEventListener('click', triggerCOD, true);
    });
  }

  function init() {
    if (initialized) return;
    if (!isProductPage()) return;
    var moved = moveCODButton();
    hideThemeProductInfo();
    interceptCartClicks();
    if (moved) initialized = true;
  }

  function bootstrap() {
    if (isProductPage()) interceptCartClicks();
    var tries = 0;
    var poll = setInterval(function () {
      if (document.querySelector('#rsi_buy_now_button') || window._rsiV2) {
        clearInterval(poll);
        init();
      } else if (++tries > 80) {
        clearInterval(poll);
        init();
      }
    }, 200);
    codObserver = new MutationObserver(function () {
      if (!initialized && isProductPage() && document.querySelector('#rsi_buy_now_button')) {
        init();
      }
      if (isProductPage()) interceptCartClicks();
    });
    codObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
